import { createSelector } from "@ngrx/store";
import {
  selectDoesUserHaveAction,
  selectToken,
} from "@app/shared/state/authentication/authentication.selectors";
import { ResourceActions } from "@app/constants/resource-actions";

export const selectViewModel = createSelector(
  selectToken,
  selectDoesUserHaveAction(ResourceActions.SupplierBiDataRead),
  (token, doesUserHaveDashboardAccess) => ({
    token,
    doesUserHaveDashboardAccess,
  }),
);
